module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_iter-step.js
// module id = KB1o
// module chunks = 43